import { useMutation, useQueryClient } from "@tanstack/react-query";

// Ações do admin sobre uma conta (verificar e-mail, reenviar verificação, gerar link de
// senha, trocar perfil): todas recebem { id, ... } e, ao terminar, atualizam a listagem e
// o detalhe — o prefixo ["admin", "users"] cobre os dois.
export function useAdminUserActionMutation(action) {
  const queryClient = useQueryClient();
  return useMutation({
    // só as variáveis: o React Query passa um segundo argumento (contexto) ao mutationFn
    mutationFn: (variables) => action(variables),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admin", "users"] }),
  });
}
